<template>
  <div id="app">
    <index />
  </div>
</template>

<script>
import index from "./components/index.vue";

export default {
  name: "App",
  components: {
    index,
  },
};
</script>

<style>
html,body,#app{
  width: 100% !important;
  height: 100% !important;
  padding: 0;
  margin: 0;
}
#app {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
@media screen and (min-width: 1281px) and (max-width: 1366px){
  html {
    font-size: 12px ;
  }
}
@media screen and (min-width: 1367px) and (max-width: 1440px) {
	html{
		font-size:14px
	}
}
@media screen and (min-width: 1441px) and (max-width: 1920px) {
	html{
		font-size:16px
	}
}
@media screen and (min-width: 1921px) and (max-width: 2194px) {
	html{
		font-size:18px
	}
}
@media screen and (min-width: 2195px) and (max-width: 2559px) {
    html{
		font-size:20px
	}
}
@media screen and (min-width: 2560px) and (max-width: 3071px) {
	html{
		font-size:22px
	}
}
@media screen and (min-width: 3072px) and (max-width: 3839px) {
	html{
		font-size:24px
	}
}
@media screen and (min-width: 3840px){
	html{
		font-size:26px
	}
}
</style>
